<template>
  <div>
    <div class="air__utils__scrollTable mb-4">
      <a-table
        :rowKey="record => record.id"
        :columns="columns"
        :dataSource="data"
        :pagination="false"
        :scroll="{ x: '100%' }"
        :rowSelection="computedSelect"
        :loading="loading"
      >
        <template slot="action" slot-scope="text, record">
          <div class="text-nowrap">
            <!-- Edit -->
            <a href="javascript:;" class="btn btn-sm btn-light btn-with-addon mr-2"
               @click="showEditModal(record)"
            >
              <span class="btn-addon">
                <i class="btn-addon-icon fe fe-edit" />
              </span>
              Edit
            </a>

            <!-- Delete -->
            <a href="javascript:;" class="btn btn-sm btn-danger btn-with-addon"
               @click="onDelete(record)"
            >
              <span class="btn-addon">
                <i class="btn-addon-icon fe fe-trash" />
              </span>
              Delete
            </a>

          </div>
        </template>
      </a-table>
    </div>
    <edit-hostel @onEdited="handleAfteredit" />
  </div>
</template>

<script>
import EditHostel from '@/components/hostel/manage/hostel/edit'
const columns = [
  { title: 'Hostel', width: 200, className: 'text-wrap', dataIndex: 'name', scopedSlots: { customRender: 'name' } },
  { title: 'Type', width: 100, className: 'text-center', dataIndex: 'type', scopedSlots: { customRender: 'type' } },
  { title: 'Description', width: 200, className: 'text-center text-wrap', dataIndex: 'description', scopedSlots: { customRender: 'description' } },
  { title: 'Total Blocks', width: 100, className: 'text-center', dataIndex: 'blocks_count', scopedSlots: { customRender: 'blocks_count' } },
  { title: 'Total Rooms', width: 100, className: 'text-center', dataIndex: 'rooms_count', scopedSlots: { customRender: 'rooms_count' } },
  { title: 'Total Students', width: 100, className: 'text-center', dataIndex: 'enrolled_students_count', scopedSlots: { customRender: 'enrolled_students_count' } },
  { title: 'Actions', width: 200, className: 'text-right', scopedSlots: { customRender: 'action' } },
]

export default {
  name: 'HostelTable',
  components: {
    EditHostel,
  },
  props: {
    select: Boolean,
    loading: Boolean,
    data: {
      type: Array,
      default: () => [],
    },
  },
  data: function() {
    return {
      columns,
    }
  },
  computed: {
    computedSelect: function() {
      if (!this.select) {
        return null
      }
      return {
        selectedRowKeys: this.selectedRowKeys,
        onChange: this.onSelectChange,
      }
    },
  },
  methods: {
    showEditModal(record) {
      this.$eventBus.$emit('openEditForm', record)
    },
    handleAfteredit() {
      this.$emit('updateTable')
    },
    onDelete: function(record) {
      this.$confirm({
        title: 'Are you sure delete this hostel?',
        content: `You are about to delete ${record.name}.`,
        okText: 'Yes',
        okType: 'danger',
        cancelText: 'No',
        onOk: () => {
          this.$nprogress.start()
          this.$http
            .delete('/api/hostel/' + record.id)
            .then(() => {
              this.$emit('updateTable')
              this.$nprogress.done()
              this.$notification['success']({
                message: 'Deleted Successfully!',
                description: record.name + ' has been deleted.',
              })
            })
            .catch(error => {
              this.$nprogress.done()
              this.$neoNotify.error(error)
            })
        },
        onCancel: () => {
          console.log('Cancel')
        },
      })
    },
  },
}
</script>
